var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 46,
    r: 46,
    fill: "#28519E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0059 28.7476C71.6198 30.368 71.6431 33.0189 70.058 34.6687L41.8982 63.9777C41.1281 64.7793 40.0751 65.2308 38.976 65.2308C37.8769 65.2308 36.8239 64.7793 36.0537 63.9777L23.2538 50.6554C21.6687 49.0056 21.692 46.3547 23.306 44.7344C24.9199 43.114 27.5132 43.1379 29.0983 44.7877L38.976 55.0684L64.2135 28.801C65.7986 27.1512 68.3919 27.1273 70.0059 28.7476Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.80edb43fd905539379d51b080c1aa277.svg";
export { ForwardRef as ReactComponent };